<style lang="scss" scoped>
.card-item {
  margin: -10px -5px;
}
</style>
<template>
  <div>
    <jijiu-page-title title="发起" :prefix="prefix"></jijiu-page-title>
    <faqi-jieshou-form class="mt10" @sub="submit" aspect-user="init"
                       :has-emergency-referral="hasEmergencyReferral"></faqi-jieshou-form>
    <el-radio-group size="mini" v-model="status" class="mt10">
      <el-radio-button v-for="(item,idx) in statusArr" :label="item.id" :key="idx">{{ item.name }}</el-radio-button>
    </el-radio-group>
    <div class="list flex mt10 wrap" v-loading="appShowLoading">
      <el-card class="flex0" :style="mixinCardStyle" v-for="(item,idx) in list" :key="idx"
               :class="{ml15:idx%3>0,mt15:idx>2}">
        <router-link tag="div" :to="{path:'/staff/detail',query:{id:item.id,aspectUser:'init',hasEmergencyReferral}}"
                     class="card-item pointer">
          <h3 class="flex aic">
            <span class="fs14">{{ item.patName }}</span>
            <span class="fs14 ml10">{{ item.patGender|sexFilter }}</span>
            <span class="fs14 ml10">{{ item.patAge }}岁</span>
            <div class="flex1 ml10">
              <el-tag type="warning">{{ getDispatchingCarDesc(item) }}</el-tag>
            </div>
            <span class="fs14 color_main">{{ item.referralStatusDesc }}</span>
          </h3>
          <div class="fs18 mt10">
            {{ item.initHosName }} → {{ item.hopeHosName }}
          </div>
          <div class="mt10 color_777 flex fs12">
            <span class="flex1">编号:{{ item.emergencyyReferralOrderNo }}</span>
            <span>{{ item.createTime|timeFilter('YYYY-MM-DD HH:mm:ss') }} 申请</span>
          </div>
        </router-link>
      </el-card>
    </div>
    <div class="mt10">
      <el-pagination
          background
          :page-size="page.pageSize"
          layout="total, prev, pager, next"
          :total="page.total"
          @current-change="this.getList">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import JijiuPageTitle from "../components/jijiu-page-title";
import FaqiJieshouForm from "../components/faqi-jieshou-form";
import {ContentWidthMixin} from "../../../common/lib/mixins/contentWidth";
import {ASPECTUSER, STAFF_ORDER_STATUS} from "../config";
import {staffService} from "../service/staff";
import {sexFilter, timeFilter} from "../../../common/lib/filters";
import {STAFF_ADD_ORDER_SUCCESS} from "../events";
import {DispatchingCarMixin, hasEmergencyReferralMixin} from "../mixins";
import fa from "element-ui/src/locale/lang/fa";

export default {
  name: 'jijiu-faqi',
  filters: {sexFilter, timeFilter},
  components: {FaqiJieshouForm, JijiuPageTitle},
  mixins: [DispatchingCarMixin, ContentWidthMixin, hasEmergencyReferralMixin],
  data() {
    const statusArr = [].concat(STAFF_ORDER_STATUS);
    // statusArr[0].name = '申请中';
    return {
      aspectUser: ASPECTUSER.init,
      page: {
        pageNum: 1,
        pageSize: 9
      },
      form: {},
      list: [],
      status: 'NEED_EXAMINE',
      statusArr
    }
  },
  computed: {},
  created() {
    this.setHasEmergencyReferral();
    this.setStatusArray();
    /*监听*/
    // eslint-disable-next-line no-undef
    bus.$on(STAFF_ADD_ORDER_SUCCESS.id, this.getList);
    this.getList();
    this.count();
  },
  beforeDestroy() {
    // eslint-disable-next-line no-undef
    bus.$off(STAFF_ADD_ORDER_SUCCESS.id, this.getList);
  },
  watch: {
    status() {
      this.getList();
    }
  },
  methods: {
    async count() {
      for (let i = 0; i < this.statusArr.length; i++) {
        const status = this.statusArr[i];
        const {page} = await staffService.listOrder({
          aspectUser: ASPECTUSER.init, statusList: [status.id],
          hasEmergencyReferral: this.hasEmergencyReferral
        });
        const oldName = status.oldName || status.name;
        this.statusArr.splice(i, 1, {
          ...status,
          total: page.total,
          oldName: oldName,
          name: oldName + `(${page.total || 0})`
        });
      }
    },
    submit(form) {
      this.form = form;
      this.getList();
    },
    updateCount() {
      const {page, status, statusArr} = this;
      const idx = statusArr.findIndex(r => r.id === status);
      statusArr.splice(idx, 1, {
        ...statusArr[idx],
        total: page.total,
        name: statusArr[idx].oldName + `(${page.total})`
      })
    },
    async getList(p) {
      const {pageSize, pageNum} = this.page;
      const {list, page} = await staffService.listOrder({
        ...this.form,
        aspectUser: ASPECTUSER.init,
        statusList: [this.status],
        pageNo: parseInt(p) || pageNum || 1,
        pageSize: pageSize,
        hasEmergencyReferral: this.hasEmergencyReferral
      });
      this.list = list;
      this.page = page;
      this.updateCount();
      this.$nextTick(() => {
        this.mixinInitContentWidth();
      })
    }
  },

}
</script>
